import { QueryClient } from '@tanstack/react-query'

// Data is refreshed by the global RefreshProvider, not per query, so queries are
// considered fresh until the next tick invalidates them.
export const queryClient = new QueryClient({
  defaultOptions: {
    queries: {
      staleTime: 55_000,
      retry: 1,
      refetchOnWindowFocus: false,
    },
  },
})
